<div class="container-fluid mt-5">
    <!-- Table -->
    <div class="row">
        <div class="col">
            <div class="card shadow">
                <div class="card-header border-0">
                    <h2>Contactez nous</h2>
                </div>
                <div class="card-body border-0">
                    <form id="contactForm" [formGroup]="FormContact" (ngSubmit)="onSubmit()">
                        <div class="row">
                            <div class="col-lg-6 col-sm-6">
                                <div class="form-group">
                                    <label>Nom et prénom :</label>
                                    <input [ngClass]="{'border-danger':contact.full_name.errors && submitFormContact}"
                                        type="text" formControlName="full_name" id="full_name" class="form-control">
                                </div>
                            </div>
                            <div class="col-lg-6 col-sm-6">
                                <div class="form-group">
                                    <label>Adresse email :</label>
                                    <input [ngClass]="{'border-danger':contact.email.errors && submitFormContact}"
                                        type="email" formControlName="email" id="email" class="form-control"
                                        EmailValidator>
                                </div>
                            </div>
                            <div class="col-lg-6 col-sm-6">
                                <div class="form-group">
                                    <label>Numéro téléphone :</label>
                                    <input [ngClass]="{'border-danger':contact.phone.errors && submitFormContact}"
                                        type="text" formControlName="phone" id="phone" class="form-control">
                                </div>
                            </div>
                            <div class="col-lg-6 col-sm-6">
                                <div class="form-group">
                                    <label>Motifs :</label>
                                    <select formControlName="departement" id="departement" class="form-control text-uppercase">
                                        <option value="autres">autres</option>
                                        <option value="passculture">passculture</option>
                                        <option value="remboursement">remboursement</option>
                                        <option value="conseil-commercial">conseil commercial</option>
                                        <option value="conseil-technique">conseil technique</option>
                                        <option value="incidents-techniques">incidents techniques</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-6 col-sm-6">
                                <div class="form-group">
                                    <label>Sujet :</label>
                                    <input [ngClass]="{'border-danger':contact.subject.errors && submitFormContact}"
                                        type="text" formControlName="subject" id="subject" class="form-control">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <label>Message :</label>
                                    <ckeditor [editor]="Editor" formControlName="message"></ckeditor>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 text-right">
                                <button type="submit" class="btn btn-studiomap"><i class="fa fa-envelope"
                                        style="margin: 0 !important;"></i> <span class="d-none d-lg-inline-block"
                                        style="margin-left: 0.5rem;">Envoyer</span></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>